import "../i18nFallback";
import "../sentryInstrumentReact";
import React from 'react';

function NoItems() {

  return(
    <>
      <div className="cart-body empty-cart">
        <div className="container">
          <div className="cart-rows text-center">
            <svg className="icon icon-yuge" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className="cartblah" d="M144,96v32h160v-32c0-44.2-35.8-80-80-80s-80,35.8-80,80ZM128,144H48c-17.7,0-32,14.3-32,32v240c0,44.2,35.8,80,80,80h256c44.2,0,80-35.8,80-80v-240c0-17.7-14.3-32-32-32h-80v88c0,4.4-3.6,8-8,8s-8-3.6-8-8v-88h-160v88c0,4.4-3.6,8-8,8s-8-3.6-8-8v-88ZM128,128v-32C128,43,171,0,224,0s96,43,96,96v32h80c26.5,0,48,21.5,48,48v240c0,53-43,96-96,96H96c-53,0-96-43-96-96v-240c0-26.5,21.5-48,48-48h80Z"/><path className="cartblah" d="M295.96,272.82c2.72-2.72,2.72-7.11,0-9.8s-7.11-2.72-9.8,0l-21.56,21.5c-11.1-8.93-25.23-14.31-40.6-14.31-35.75,0-64.73,28.99-64.73,64.73,0,15.37,5.38,29.51,14.31,40.6l-21.53,21.53c-2.72,2.72-2.72,7.11,0,9.8,2.72,2.69,7.11,2.72,9.8,0l21.53-21.53c11.1,8.96,25.23,14.31,40.6,14.31,35.75,0,64.73-28.99,64.73-64.73,0-15.37-5.38-29.51-14.31-40.6l21.56-21.5ZM254.72,294.41l-71.27,71.27c-6.47-8.53-10.32-19.19-10.32-30.72,0-28.09,22.77-50.86,50.86-50.86,11.53,0,22.19,3.84,30.72,10.32ZM193.28,375.5l71.27-71.27c6.47,8.53,10.32,19.19,10.32,30.72,0,28.09-22.77,50.86-50.86,50.86-11.53,0-22.19-3.84-30.72-10.32Z"/></svg>
            <p>{window.gettext("There are no items in your cart.")}</p>
            <p><a href={window.gettext("/store/")} className="btn btn-cart-secondary">{window.gettext("Continue Shopping")}</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default NoItems;
